import React, { useEffect } from "react";
import classNames from "classnames";

import { Handle, Remove } from "./components";

import styles from "./Item.module.css";
import { Tooltip } from "@material-ui/core";
import InlineConfirm from "../InlineConfirm";

export const Item = React.memo(
	React.forwardRef(
		(
			{
				color,
				dragOverlay,
				dragging,
				disabled,
				fadeIn,
				handle,
				handleProps,
				height,
				index,
				listeners,
				onRemove,
				renderItem,
				sorting,
				style,
				transition,
				transform,
				value,
				wrapperStyle,
				isPreviewMode,
				resources,
				...props
			},
			ref
		) => {
			useEffect(() => {
				if (!dragOverlay) {
					return;
				}

				document.body.style.cursor = "grabbing";

				return () => {
					document.body.style.cursor = "";
				};
			}, [dragOverlay]);

			return (
				<li
					className={classNames(
						styles.Wrapper,
						fadeIn && styles.fadeIn,
						sorting && styles.sorting,
						dragOverlay && styles.dragOverlay
					)}
					style={{
						...wrapperStyle,
						transition: [transition, wrapperStyle?.transition]
							.filter(Boolean)
							.join(", "),
						"--translate-x": transform?.x
							? `${Math.round(transform.x)}px`
							: undefined,
						"--translate-y": transform?.y
							? `${Math.round(transform.y)}px`
							: undefined,
						"--scale-x": transform?.scaleX ? `${transform.scaleX}` : undefined,
						"--scale-y": transform?.scaleY ? `${transform.scaleY}` : undefined,
						"--index": index,
						"--color": color,
					}}
					ref={ref}
				>
					<div
						className={classNames(
							styles.Item,
							dragging && styles.dragging,
							handle && styles.withHandle,
							dragOverlay && styles.dragOverlay,
							disabled && styles.disabled,
							color && styles.color,
							isPreviewMode && styles.preview
						)}
						style={{ ...style }}
						{...(!handle ? listeners : undefined)}
						{...props}
						tabIndex={!handle ? 0 : undefined}
					>
						<div
							className="d-flex align-items-center w-100"
							style={{ gap: "8px" }}
						>
							{handle && !isPreviewMode ? (
								!dragOverlay ? (
									<Tooltip title={resources["DragToReorderTooltip"]}>
										<span>
											<Handle {...handleProps} {...listeners} />
										</span>
									</Tooltip>
								) : (
									<Handle {...handleProps} {...listeners} />
								)
							) : null}

							{renderItem ? renderItem(value) : value}
						</div>

						<span className={styles.Actions}>
							{onRemove && !isPreviewMode ? (
								<InlineConfirm onConfirm={onRemove} resources={resources}>
									<Tooltip title={resources["DeleteItemTooltip"]}>
										<span>
											<Remove id={`remove-item-${value}`} />
										</span>
									</Tooltip>
								</InlineConfirm>
							) : null}
						</span>
					</div>
				</li>
			);
		}
	)
);
